export default __webpack_public_path__ + "locales/si/EmptyTrashDialog.json?hash=c21c11c8505923f0e785adebddd459ac";